/* eslint-disable react/prop-types */
import React from 'react';
import Helmet from 'react-helmet';

const Analytics: React.FC = () => (
  <>
    <noscript
      dangerouslySetInnerHTML={{
        __html: `
                <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WBG5Z44"
                            height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
      }}
    />
    <Helmet
      script={[
        {
          type: 'text/javascript',
          innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-WBG5Z44');`,
        },
      ]}
    />
    <Helmet>
      <script async src="https://awwtag.emaww.com/js?token=AWW-382978285-1" />
    </Helmet>
    <Helmet
      script={[
        {
          type: 'text/javascript',
          innerHTML: `(function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0); branch.init('${
            process.env.GATSBY_BRANCH_KEY || ''
          }');`,
        },
      ]}
    />
    <Helmet
      script={[
        {
          type: 'text/javascript',
          innerHTML: `!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="${
            process.env.GATSBY_SEGMENT_API_KEY || ''
          }";;analytics.SNIPPET_VERSION="4.15.3"; analytics.load("${
            process.env.GATSBY_SEGMENT_API_KEY || ''
          }");
            analytics.page();
          }}();`,
        },
      ]}
    />
    <Helmet>
      <link rel="dns-prefetch" href="//www.googletagmanager.com" />
      <link rel="dns-prefetch" href="//www.google-analytics.com" />
    </Helmet>
  </>
);

export default Analytics;
